(function () {
	const collapsibleContentButtons = document.querySelectorAll('.collapsible__heading');
	collapsibleContentButtons.forEach(button => {
		button.addEventListener('click', () => {
			console.log(button.parentNode)
			if (button.parentNode.classList.contains('expanded')) {
				button.parentNode.classList.remove('expanded');
				button.parentNode.querySelector('.collapsible__content').setAttribute('aria-hidden', true);
			} else {
				button.parentNode.classList.add('expanded');
				button.parentNode.querySelector('.collapsible__content').setAttribute('aria-hidden', false);
			}
		});
	});
})();
